import React from 'react';

class Page extends React.Component {

  constructor(props) {
    super(props);
    this.step = props.step ? parseInt(props.step) : 0;
  }

  render() {

    const stepList = [];
    let step = 0;

    for (let i = 0; i < 11; i++) {

      const classes = [];
      classes.push(i % 2 === 0 ? 'bullet' : 'line');
      classes.push(step <= this.step ? ' complete' : '');

      stepList.push(<div key={i} className={ classes.join('') }></div>);

      if (i % 2 === 0) step++;
    }


    return (
      <div className="flex flex-col" >
        <div className="steps">
          {stepList}
        </div>
        <div className="main">
          <div className="content">
          {this.props.children}
          </div>
        </div>
        <div className="footer">
          <button onClick={this.props.handleStep}>Próximo</button>
        </div>
      </div>
    );
  }
}


export default Page;